module.exports = __webpack_public_path__ + "static/media/flying_ceilin_dad.e5f9c13b.jpeg";